'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from 'cn';
type LabelProps = React.ComponentProps<'label'>;
export function Label(props) {
  const $ = _c(8);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <label data-slot="label" className={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}